export const getFontStyle = (font: string) => {
  switch (font) {
    case "Cardium A":
      return { fontFamily: "var(--ct_font_regular)" };
    case "Roboto":
      return { fontFamily: "var(--ct_font_roboto)" };
    case "Quicksand":
      return { fontFamily: "var(--ct_font_quicksand)" };
    case "Arial":
      return { fontFamily: "var(--ct_font_arial)" };
    case "Verdana":
      return { fontFamily: "var(--ct_font_verdana)" };
    case "IBM Plex Serif":
      return { fontFamily: "var(--ct_font_ibm_plex_serif)" };
    case "Noto Sans":
      return { fontFamily: "var(--ct_font_noto_sans)" };
    case "Merriweather":
      return { fontFamily: "var(--ct_font_merriweather)" };
    case "Crimson":
      return { fontFamily: "var(--ct_font_crimson)" };
    case "Garamond":
      return { fontFamily: "var(--ct_font_garamond)" };
    default:
      return { fontFamily: "var(--ct_font_regular)" };
  }
};

const serifFonts = new Set([
  "crimson",
  "garamond",
  "ibm plex",
  "ibm plex serif",
  "quicksand",
  "merriweather"
]);

export const getFontClass = (font: string) =>
  serifFonts.has((font || "").toLowerCase()) ? "custom-font-serif" : "";
